import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import ListPortfolio from '../../components/Projects';
import ListCaseStudies from '../../components/ListCaseStudies';
import { ListPortfolioTags } from '../../components/Projects/Tags';

const ProjectList = ({ input }) => (
  <StaticQuery
    query={graphql`
      query ProjectSliceQuery {
        allPrismicClient(sort: { fields: data___sort_date, order: DESC }) {
          edges {
            node {
              ...prismicClientProject
            }
          }
        }
      }
    `}
    render={data => {
      const projectCaseStudies = data.allPrismicClient.edges
        .map(({ node }) => {
          return node.data.content.length > 0 ? node : null;
        })
        .filter(function(el) {
          return el != null;
        });

      const projectPortfolios = data.allPrismicClient.edges
        .map(({ node }) => {
          return node.data.content.length <= 0 ? node : null;
        })
        .filter(function(el) {
          return el != null;
        });

      return input.primary.project_type === 'Portfolio' ? (
        <>
          <ListPortfolioTags />
          <ListPortfolio projects={projectPortfolios} />
        </>
      ) : (
        <ListCaseStudies input={projectCaseStudies} />
      );
    }}
  />
);

ProjectList.propTypes = {
  input: PropTypes.object.isRequired,
};

export default ProjectList;
